<div class="min-h-screen flex items-center justify-center bg-surface-50 px-4">
  @if (loading()) {
    <div class="flex flex-col items-center gap-3 text-surface-600">
      <i class="pi pi-spin pi-spinner text-3xl"></i>
      <p class="text-sm m-0">Cargando suscripción…</p>
    </div>
  } @else if (error()) {
    <div class="max-w-md w-full rounded-xl border border-red-200 bg-white p-6 text-center shadow-sm">
      <i class="pi pi-exclamation-circle text-3xl text-red-500 mb-3"></i>
      <h1 class="text-lg font-semibold text-surface-900 m-0 mb-2">No disponible</h1>
      <p class="text-sm text-surface-600 m-0">{{ errorMessage() || 'No se pudo cargar la suscripción.' }}</p>
    </div>
  }
</div>
